"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var styles=require("@material-ui/core/styles");let i=styles.makeStyles(e=>({phoneIcon:{marginRight:e.spacing(1)},phoneText:{marginRight:e.spacing(3)}}));exports.default=i;
//# sourceMappingURL=styles.js.map
